import { render, staticRenderFns } from "./LogworkApproval.vue?vue&type=template&id=5146151b&scoped=true&"
import script from "./LogworkApproval.vue?vue&type=script&lang=js&"
export * from "./LogworkApproval.vue?vue&type=script&lang=js&"
import style0 from "./LogworkApproval.vue?vue&type=style&index=0&id=5146151b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5146151b",
  null
  
)

export default component.exports